import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    getUsersMissingCustomAttributes,
    getUsersWithoutManager,
    getUsersWithDuplicateEmployeeId,
    getUsersWithManagerDisabled,
    getUsersNotInConstellationToutLeMonde,
    getUsersNotInTeamToutLeMonde,
    getUsersBALWithManager,
    getUsersBALWithoutSponsors,
    getUsersBALOwnerOfGroup,
    getUsersBALWithLicense,
    getUsersWithoutLicenseIntune,
    getUsersWithoutLicenseDefender,
    getUsersManagerWithoutGrpSecManager,
    getUsersManagerWithoutCustomAttribute5,
    getUsersWithMultipleLaptop,
    getUsersWithoutLaptop,
    getUsersExternalWithoutDesactivationDate,
    getUsersBALWithGroup,
} from "../../api/internal/usersInternalApi";

// Map clé → fonction API
const apiMap = {
    usersWithoutManager: getUsersWithoutManager,
    usersMissingCustomAttributes: getUsersMissingCustomAttributes,
    usersWithDuplicateEmployeeId: getUsersWithDuplicateEmployeeId,
    usersWithManagerDisabled: getUsersWithManagerDisabled,
    usersNotInConstellationToutLeMonde: getUsersNotInConstellationToutLeMonde,
    usersNotInTeamToutLeMonde: getUsersNotInTeamToutLeMonde,
    usersBALWithManager: getUsersBALWithManager,
    usersBALWithoutSponsors: getUsersBALWithoutSponsors,
    usersBALOwnerOfGroup: getUsersBALOwnerOfGroup,
    usersBALWithLicense: getUsersBALWithLicense,
    usersBALWithGroup: getUsersBALWithGroup,
    usersWithoutLicenseIntune: getUsersWithoutLicenseIntune,
    usersWithoutLicenseDefender: getUsersWithoutLicenseDefender,
    usersManagerWithoutGrpSecManager: getUsersManagerWithoutGrpSecManager,
    usersManagerWithoutCustomAttribute5: getUsersManagerWithoutCustomAttribute5,
    usersWithMultipleLaptop: getUsersWithMultipleLaptop,
    usersWithoutLaptop: getUsersWithoutLaptop,
    usersExternalWithoutDesactivationDate: getUsersExternalWithoutDesactivationDate,
};

const allKeys = Object.keys(apiMap);

// Un thunk distinct par clé
const dashboardThunks = {};
allKeys.forEach((key) => {
    dashboardThunks[key] = createAsyncThunk(
        `dashboard/fetch_${key}`,
        async (_, { signal }) => {
            const data = await apiMap[key](signal);
            return data;
        },
    );
});

// Dispatch tous les fetches en parallèle
export const fetchAllDashboardData = () => (dispatch) => {
    allKeys.forEach((key) => dispatch(dashboardThunks[key]()));
};

// Ne fetch que si aucune donnée n'a encore été chargée
export const fetchDashboardDataIfNeeded = () => (dispatch, getState) => {
    const { dashboard } = getState();
    if (!dashboard.lastFetched) {
        dispatch(fetchAllDashboardData());
    }
};

const initialState = {
    data: allKeys.reduce((acc, key) => ({ ...acc, [key]: [] }), {}),
    isLoading: allKeys.reduce((acc, key) => ({ ...acc, [key]: true }), {}),
    lastFetched: null,
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        allKeys.forEach((key) => {
            builder
                .addCase(dashboardThunks[key].pending, (state) => {
                    state.isLoading[key] = true;
                })
                .addCase(dashboardThunks[key].fulfilled, (state, action) => {
                    state.data[key] = action.payload;
                    state.isLoading[key] = false;
                    state.lastFetched = new Date().toISOString();
                })
                .addCase(dashboardThunks[key].rejected, (state) => {
                    state.isLoading[key] = false;
                });
        });
    },
});

export default dashboardSlice.reducer;